// extracted by mini-css-extract-plugin
export default {"iconfont":"icon_iconfont__GDjEN"};